import React from 'react';
import { Container, Button } from 'react-bootstrap';

export default function StepFinalOrientacionUtu({ reset }) {
  return (
    <Container className="form-container text-center">
      <h2 className="form-title">Gracias por tu interés</h2>
      <p>
        Lamentablemente, en este momento tenemos solución para las orientaciones: Deporte y recreación, Informática y Administración. En caso de que surja alguna opción para tu orientación, nos pondremos en contacto! Estamos actualmente buscando formas de darte una solución.
      </p>
      <Button variant="primary" onClick={reset} className="mt-3 botonfinalreiniciar">
        Reiniciar formulario
      </Button>
    </Container>
  );
}
